export const Country = ({ scale = 1 }: { scale?: number }) => {
  return (
    <svg
      width={16 * scale}
      height={16 * scale}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.67554 8H14.3245"
        stroke="#35332F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.20111 1.56946C10.0426 3.45571 12.6206 8.83939 8.20111 14.4316"
        stroke="#35332F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.01423 1.56946C6.17276 3.45571 3.59469 8.83939 8.01423 14.4316"
        stroke="#35332F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99991 1.5C11.5894 1.5 14.5001 4.40996 14.5001 8.00016C14.5001 11.5897 11.5894 14.5003 7.99991 14.5003C4.40972 14.5003 1.49976 11.5897 1.49976 8.00016C1.49976 4.40996 4.40972 1.5 7.99991 1.5Z"
        stroke="#35332F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
